export const verifyToken = async (token) => {
    if (!token) return false;

    try {
        const res = await fetch('/api/v1/auth', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return res.ok;
    } catch (err) {
        return false;
    }
};
